export default function (value) {
  function capitalize(word, index) {
    return index > 0 ? word : word.charAt(0).toUpperCase() + word.substring(1);
  }

  var words = value.match(/[A-Za-z][a-z]*/g) || [];

  return words.map(capitalize).join(" ");
}
